import { QueueDocument, QueueRejectionReasons } from 'types';

export function getDocumentIdToQueueItemMap(queueItems?: any[]) {
  const map: Record<string, QueueDocument> = {};
  for (const queueItem of queueItems ?? []) {
    for (const rawId of queueItem.documentIds ?? []) {
      const key = rawId?.toString?.();
      if (!map[key]) map[key] = queueItem;
    }
  }
  return map;
}

export function getRejectionsByDocumentId(queueItems?: any[]) {
  const result = new Map<string, QueueRejectionReasons[]>();
  for (const queueItem of queueItems ?? []) {
    for (const rejection of queueItem.rejectionReasons ?? []) {
      const key = rejection?.rejectedDocumentId?.toString?.();
      if (!key) continue;
      if (!result.has(key)) result.set(key, []);
      result.get(key)!.push(rejection);
    }
  }
  return result;
}
